export default __webpack_public_path__ + "Mask-group-5.fe550a.svg";